export enum AssignmentStatusEnum {
  new = 'New',
  assigned = 'Assigned',
  app = 'App',
  noApp = 'NoApp',
  hold = 'Hold',
  closed = 'Closed',
  continue = 'Continue',
  continueOk = 'ContinueOk',
  sync = 'Synchronization',
  cancelled = 'Cancelled',
  rejected = 'Rejected',
  stopped = 'Stopped',
  inProgress = 'InProgress',
}

export enum AssignmentLoadPriorityEnum {
  none = 'NoPriority',
  asap = 'AsSoonAsPossible',
  before = 'Before',
  after = 'After',
  exactlyAt = 'ExactlyAt',
  between = 'Between',
}

export enum AssignmentPriorityEnum {
  priority1 = 'Priority1',
  priority2 = 'Priority2',
  priority3 = 'Priority3',
  priority4 = 'Priority4',
  priority5 = 'Priority5',
  priority6 = 'Priority6',
  priority7 = 'Priority7',
  priority8 = 'Priority8',
  priority9 = 'Priority9',
  priority10 = 'Priority10',
}

export class AssignmentApiModel {
  number: string;
  orderLineNumber: string;
  orderNumber: string;
  requestedVehicleTypeName: string;
  vehiclePlateNumber: string;
  driverName: string;
  customerProjectId: number;
  customerProjectName: string;
  customerProjectNumber: string;
  projectId: number;
  projectName: string;
  projectNumber: string;
  productTypeName: string;
  productGroupName: string;
  deliveriesCount: number;
  assignmentId: number;
  assignmentKey: string;
  orderId: number;
  orderLineId: number;
  productTypeId: number;
  driverId: number;
  vehicleId: number;
  requestedVehicleTypeId: number;
  startDate: Date;
  endDate: Date;
  comment: string;
  status: AssignmentStatusEnum;
  orderIndex: number;
  loadingDateTime: Date;
  loadingTimePriority: AssignmentLoadPriorityEnum;
  loadingSiteId: number;
  loadingSiteName: string;
  loadingAddress: string;
  loadingAddressGeoLocation: string;
  loadingComment: string;
  loadingCustomerProjectId: number;
  unloadingDateTime: Date;
  unloadingTimePriority: AssignmentLoadPriorityEnum;
  unloadingSiteId: number;
  unloadingSiteName: string;
  unloadingAddress: string;
  unloadingAddressGeoLocation: string;
  unloadingComment: string;
  unloadingCustomerProjectId: number;
  isConfirmedByDriver: boolean;
  isActive: boolean;
  quantity: number;
  unitName: string;
  unitId: number;
  isRequestedVehicleWithTrailer: boolean;
  contactTransportId: number;
  contactTransportFullName: string;
  contactTransportPhone: string;
  customerId: number;
  customerKey: string;
  customerName: string;
  priority: AssignmentPriorityEnum;
  loadAddressId: number;
  unloadAddressId: number;
  isReturnDelivery: boolean;
}

export interface AssignmentModel extends AssignmentApiModel {}
